import React from 'react'
import '../Scss/Login.scss'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { TextField, withStyles } from '@material-ui/core';
import * as yup from 'yup';

const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: 'grey',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#dc3545',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#dc3545',
        },
        '&:hover fieldset': {
          borderColor: '#dc3545',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#dc3545',
        },
      },
    },
})(TextField);

//validation 
const ValidationSchema = yup.object({
    email: yup
        .string()
        .email('Invalid email!')
        .required('Required!'),
    password: yup
        .string()
        .required('Required!'),
    comfirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Password not match')
        .required('Required!')
}) 

const SignUp = () =>{
    return(
        <div className="login-container">
            
            <Formik
                    initialValues={{
                        email: '',
                        password: '',
                        comfirmPassword: ''
                    }}

                    validationSchema={ValidationSchema}

                    onSubmit={async(data,{setSubmitting}) => {
                        setSubmitting(true);
                        
                        //onsubmit function

                        setSubmitting(false);
                    }}
                >
                    {({ isSubmitting }) => (
                        <div className="container">
                            <div className="login-text">
                                <h1>We're The Next Generation of Real Estate Agents</h1>
                                <br />
                                <p>Perfect for buy, sell and rent the property like apartments, flats, houses, villa and rental property service.</p>
                            </div>
                            <form className="login-form text-center"> 
                                <Form>
                                    <h3>Sign Up</h3>
                                    <p className="text text-center">Already have a account? <a href="/Login">Log in</a></p>
                                    {/* text field */}
                                    <Field 
                                        name='email'
                                        label="Email"
                                        type='input'
                                        variant='outlined'
                                        as={CssTextField}
                                        style={{width:'100%'}}
                                    />
                                    <br />
                                    <ErrorMessage component="div" className="text-danger text-left" style={{fontSize:12}} name="email"/>
                                    <br />
                                    <Field 
                                        name='password'
                                        label="Password"
                                        type='password'
                                        variant='outlined'
                                        as={CssTextField}
                                        style={{width:'100%'}}
                                    />
                                    <br />
                                    <ErrorMessage component="div" className="text-danger text-left" style={{fontSize:12}} name="password"/>
                                    <br />
                                    <Field 
                                        name='comfirmPassword'
                                        label="Comfirm Password"
                                        type='password'
                                        variant='outlined'
                                        as={CssTextField}
                                        style={{width:'100%'}}
                                    />
                                    <br />
                                    <ErrorMessage component="div" className="text-danger text-left" style={{fontSize:12}} name="comfirmPassword"/>
                                    <br />
                                    <button disabled={isSubmitting} type='submit' className="btn btn-danger" >Sign Up</button>
                                    <br />
                                    <br />

                                </Form>
                                
                            </form>
                            
                        </div>
                    )}

                </Formik>
        </div>
    )
}

export default SignUp